document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-bd-set-contents]').forEach((container) => {
    const modals = container.querySelectorAll('[data-bd-set-modal]');
    const triggers = container.querySelectorAll('[data-bd-set-modal-trigger]');

    const closeModal = (modal) => {
      modal.classList.remove('is-open');
      document.body.classList.remove('bd-set-modal-open');
    };

    const openModal = (modalId) => {
      modals.forEach((modal) => {
        if (modal.dataset.bdSetModal === modalId) {
          modal.classList.add('is-open');
        } else {
          modal.classList.remove('is-open');
        }
      });
      document.body.classList.add('bd-set-modal-open');
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const modalId = trigger.dataset.bdSetModalTrigger;
        if (modalId) openModal(modalId);
      });
    });

    container.querySelectorAll('[data-bd-set-modal-close]').forEach((closeBtn) => {
      closeBtn.addEventListener('click', () => {
        const modal = closeBtn.closest('[data-bd-set-modal]');
        if (modal) closeModal(modal);
      });
    });

    container.querySelectorAll('[data-bd-set-modal-overlay]').forEach((overlay) => {
      overlay.addEventListener('click', () => {
        const modal = overlay.closest('[data-bd-set-modal]');
        if (modal) closeModal(modal);
      });
    });

    container.querySelectorAll('[data-bd-set-accordion-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const panel = trigger.nextElementSibling;
        if (!panel || !panel.hasAttribute('data-bd-set-accordion-panel')) return;
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!isOpen));
        panel.classList.toggle('is-open', !isOpen);
      });
    });
  });
});
